import axios from 'axios';

export default {
  fetchDataGrapesClient (params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/datagrapes", {params})
      .then(results=>{
        return results.data;
      })
  },
  updateDataGrapesClient (datagrapesClientId, datagrapesClient) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/datagrapes/"+datagrapesClientId, datagrapesClient)
    .then(results=>{
      return results.data;
    })
  },
  createDataGrapesClient (datagrapesClient) {
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/datagrapes", datagrapesClient)
    .then(results=>{
      return results.data;
    })
  }
}
